<template>
<span
    :class="status.color"
    class="inline-flex items-center px-2.5 py-0.5 rounded-sm text-xs
    font-medium  uppercase">{{ status.name }}
</span>

</template>

<script>
export default {
    props: {
        status: {
            type: Object,
        }
    }
}
</script>

<style scoped>

</style>
